import { render, staticRenderFns } from "./PdpRexallRaddar.vue?vue&type=template&id=5d5eb148&scoped=true&"
import script from "./PdpRexallRaddar.vue?vue&type=script&lang=js&"
export * from "./PdpRexallRaddar.vue?vue&type=script&lang=js&"
import style0 from "./PdpRexallRaddar.vue?vue&type=style&index=0&id=5d5eb148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5eb148",
  null
  
)

export default component.exports